<template>
  <div class="wrapper" :style="{ bottom: showDocker ? '0.5rem' : '0' }">
    <!-- :key="mapKey" -->

    <div v-if="isShowGoogleMap">
      <GMapMap
        v-if="isMapVisible"
        :key="mapKey"
        :center="mapCenter"
        :zoom="12"
        ref="myMapRef"
        style="width: 100%; height: 100vh"
        map-type-id="terrain"
        :options="{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
        }"
      >
        <template v-for="(location, index) in locations" :key="index">
          <GMapMarker
            v-if="location.position"
            :position="location.position"
            :clickable="true"
            :title="location.title"
            @click="onMarkerClick(location, mapCenter)"
            :icon="location.icon"
            :label="location.label || undefined"
          />
        </template>
      </GMapMap>
    </div>

    <TianDiTuMap
      v-else
      ref="tdmapref"
      v-model:locationPermission="locationPermission"
      v-model:city="city"
      :currentLocation="currentLocation"
      @update:currentLocation="
        (val) => Object.assign(currentLocation, val || {})
      "
      @onMarkerClick="onMarkerClick"
      @onDealerList="onTdDealerList"
    />

    <MapStorePanel
      :style="{ bottom: showDocker ? '0.49rem' : '0' }"
      :dealers="dealerList"
      v-model:keyword="keyword"
      v-model:city="city"
      v-model:locationPermission="locationPermission"
      :currentLocation="currentLocation"
      @update:currentLocation="
        (val) => Object.assign(currentLocation, val || {})
      "
      :activeKey="activeDealerKey"
      @select="onSelectDealerFromList"
      @navigate="onNavigateFromList"
    />

    <!-- 手机端：点击地图标记后的弹框，样式与 PC 一致，并带过渡动画 -->
    <transition name="mobilePopup">
      <div
        v-if="showMarkerPopup && selectDealerInfo.fullName"
        class="mobilePopupMask"
        @click.self="showMarkerPopup = false"
      >
        <div class="mobilePopup" @click.stop>
          <van-icon
            name="cross"
            class="mobilePopup__close"
            @click="showMarkerPopup = false"
          />
          <div class="mobilePopup__title">{{ selectDealerInfo.fullName }}</div>
          <div
            v-if="popupDealerList.length > 1"
            class="mobilePopup__switchList"
          >
            <div
              v-for="(d, idx) in popupDealerList"
              :key="d.id ?? `${d.fullName}-${idx}`"
              class="mobilePopup__switchItem"
              :class="{
                'mobilePopup__switchItem--active': idx === popupDealerIndex,
              }"
              @click="onPickPopupDealer(d, idx)"
            >
              {{ d.fullName || "-" }}
            </div>
          </div>
          <div class="mobilePopup__badge" v-if="selectDealerInfo.authRange">
            {{ $t("app.home.map_popup_auth_date_prefix")
            }}{{ selectDealerInfo.authRange }}
          </div>
          <div class="mobilePopup__row" v-if="selectDealerInfo.phone">
            <img class="mobilePopup__icon" :src="popupIconPhone" alt="" />
            <div class="mobilePopup__text">{{ selectDealerInfo.phone }}</div>
          </div>
          <div class="mobilePopup__row" v-if="selectDealerInfo.address">
            <img class="mobilePopup__icon" :src="popupIconLoc" alt="" />
            <div class="mobilePopup__text">{{ selectDealerInfo.address }}</div>
          </div>
          <div class="mobilePopup__row" v-if="selectDealerInfo.distanceText">
            <img class="mobilePopup__icon" :src="popupIconNav" alt="" />
            <div class="mobilePopup__text">
              {{ $t("app.home.map_popup_distance_prefix")
              }}{{ selectDealerInfo.distanceText }}
            </div>
          </div>
          <button class="mobilePopup__btn" @click="onGotoPlace">
            {{ $t("app.home.map_popup_nav_to") }}
          </button>
        </div>
      </div>
    </transition>
    <!-- <div class="refreshwrapper">
      <img
        :src="require('@/assets/refresh.png')"
        class="refreshwrapper__img"
        @click="onReloadMap"
      />
    </div> -->
  </div>

  <Docker :currentIndex="1" v-if="showDocker" />
  <!-- v-if="showBackImg" -->
  <!-- <img
    :src="require('@/assets/back_arrow.png')"
    class="back__img"
    @click="onBackClick"
  /> -->
</template>

<script>
/**
 * 根据定位到的经纬度 获取周边的门店
 * 然后点击能查看门店的一些信息
 */
import { reactive, toRefs, ref } from "vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  onActivated,
  onDeactivated,
  nextTick,
  watch,
} from "@vue/runtime-core";
// import { useLoadScript } from "@fawmi/vue-google-maps";
// import { useLoadScript } from "@fawmi/vue-google-maps";
import Docker from "@/components/Docker";
import MapStorePanel from "@/views/home/MapStorePanel.vue";
import {
  getGoogleMapLocation,
  getTdMapLocation,
  getOpenRetailerListApi,
  getMultiLevelDistrictApi,
} from "@/utils/neturls";
import { showToast, showSuccessToast, showFailToast } from "vant";
import { useI18n } from "vue-i18n";
import {
  GOOGLE_MAP_KEY,
  CHINA_DEFAULT_PROVINCE_ID,
  CHINA_ALL_PROVINCE,
} from "@/utils/config";
import { googleMapParam } from "@/utils/mapConfig";
import { getLanguageFlag, saveLanguageFlag } from "@/utils/localStorageUtils";
import navigatorUtils from "@/utils/navigatorUtilsOptimized";

import positionIcon from "@/assets/position.png"; // 使用 import 加载本地图标
import positionOtherIcon from "@/assets/position_other.png"; // 使用 import 加载本地图标
import myLocationIcon from "@/assets/map-icons/mylocation.png";
import { useRoute, useRouter } from "vue-router";
import { useNewLanguageEffect } from "@/effects/switchLanguageEffect";

import TianDiTuMap from "@/views/maps/TianDiTuMap.vue";
import { isInChina } from "@/utils/commonUtils";
import { calcDistanceKm } from "@/utils/geoCity";

// 地图标记弹框内行图标：使用与 PC 端一致的主题图标
import popupIconLoc from "@/assets/map-icons/map_location_theme.png";
import popupIconPhone from "@/assets/map-icons/phone_theme.png";
import popupIconNav from "@/assets/map-icons/navigation_theme.png";

const useSearchContentEffect = (mapToCenterFunc, tdMapToCenterFunc) => {
  const { onGetGoogleMapLocation } = useAddressSearchEffect();
  const onSearchClick = (value) => {
    console.log("onsearchClick", value);
    if (value) {
      // 若value存在的话 直接进行请求
      onGetGoogleMapLocation(value, mapToCenterFunc, tdMapToCenterFunc);
    }
  };
  return { onSearchClick };
};
// 搜索地址的经纬度
const useAddressSearchEffect = () => {
  const onGetGoogleMapLocation = async (
    value,
    mapToCenterFunc,
    tdMapToCenterFunc
  ) => {
    if (!isInChina()) {
      const res = await getGoogleMapLocation(value);
      if (res.status == "OK") {
        // 请求成功
        const location = res.results[0].geometry.location;
        // 获取到具体的经纬度
        console.log("获取到具体的经纬度:", location);
        const { lat, lng } = location;
        //定位到当前位置
        mapToCenterFunc(lat, lng);
      } else {
        // 获取失败
        showFailToast("get location error");
      }
    } else {
      const res = await getTdMapLocation(value);
      if (res.status == "0") {
        // 请求成功
        const location = res.location;
        // 获取到具体的经纬度
        console.log("获取到具体的经纬度:", location);

        const { lat, lon } = location;
        //定位到当前位置
        // mapToCenterFunc(lat, lng);
        tdMapToCenterFunc(lat, lon);
      } else {
        // 获取失败
        showFailToast("get location error");
      }
    }
  };
  return { onGetGoogleMapLocation };
};

// 导航效果
const useNavigatorEffect = (selectDealerInfo) => {
  const onGotoPlace = () => {
    const navigatorInfo = {
      startLatitude: selectDealerInfo.startLatitude,
      startLongitude: selectDealerInfo.startLongitude,
      endLatitude: selectDealerInfo.endLatitude,
      endLongitude: selectDealerInfo.endLongitude,
      name: selectDealerInfo.fullName,
    };
    navigatorUtils.navigateToMap(navigatorInfo);
  };

  return { onGotoPlace };
};

const useMapEffect = (t) => {
  // 加载 Google Maps 脚本
  const isMapVisible = ref(true);
  const mapKey = ref(0); // 定义 ref
  const myMapRef = ref(null); // 定义 ref
  const mapCenter = ref({ lat: 3.139, lng: 101.6869 }); // 默认中心点
  const selectDealerInfo = reactive({});
  // 默认的标记
  const locationsObj = reactive({
    locations: [
      // {
      //   position: { lat: 39.9042, lng: 116.4074 }, // 北京
      //   icon: {
      //     url: positionOtherIcon, // 使用 import 引用的图标
      //     scaledSize: { width: 40, height: 40 }, // 调整大小
      //   },
      //   title: "Beijing",
      // },
      // {
      //   position: { lat: 31.2304, lng: 121.4737 }, // 上海
      //   icon: {
      //     url: positionOtherIcon, // 使用 import 引用的图标
      //     scaledSize: { width: 40, height: 40 }, // 调整大小
      //   },
      //   title: "Shanghai",
      // },
    ],
  });
  const { locations } = toRefs(locationsObj);
  const normalizeGoogleDealerMarker = () => {
    (locations.value || []).forEach((item) => {
      if (item?.id === "dealer") {
        item.icon = {
          url: positionOtherIcon,
          scaledSize: { width: 40, height: 40 },
        };
      }
    });
  };

  const focusOnDealer = (latitude, longitude, dealer) => {
    console.log("dealerList.value one", dealer);
    console.log("dealerList.value two", locations.value);
    if (latitude == null || longitude == null) return;
    mapCenter.value = { lat: Number(latitude), lng: Number(longitude) };
    normalizeGoogleDealerMarker();
    const targetLat = Number(latitude);
    const targetLng = Number(longitude);
    const hit = (locations.value || []).find((item) => {
      if (item?.id !== "dealer" || !item?.position) return false;
      return (
        Number(item.position.lat) === targetLat &&
        Number(item.position.lng) === targetLng
      );
    });
    console.log("dealerList.value three", hit);
    if (hit) {
      hit.icon = {
        url: positionIcon,
        scaledSize: { width: 40, height: 40 },
      };
      return;
    }
    locations.value.push({
      position: { lat: targetLat, lng: targetLng },
      icon: {
        url: positionIcon,
        scaledSize: { width: 40, height: 40 },
      },
      id: "dealer",
      fullName: dealer?.fullName,
      address: dealer?.address,
      endLatitude: targetLat,
      endLongitude: targetLng,
      // distancekm: dealer?.distancekm,
    });
    //  console.log("dealerList.value two", locations.value);
  };

  const onMarkerClick = (location, mapcenter) => {
    console.log("我被调用了", location);
    if (location.id == "dealer") {
      selectDealerInfo.fullName = location.fullName;
      selectDealerInfo.address = location.address;
      selectDealerInfo.startLatitude = mapcenter
        ? mapcenter.lat
        : location.startLatitude;
      selectDealerInfo.startLongitude = mapcenter
        ? mapcenter.lng
        : location.startLongitude;
      selectDealerInfo.endLatitude = location.endLatitude;
      selectDealerInfo.endLongitude = location.endLongitude;
      selectDealerInfo.distanceText = location.distancekm;
    } else {
      showToast(t("app.home.selfplace"));
    }

    // alert(`Clicked marker: ${location.title}`);
  };

  onBeforeUnmount(() => {});

  return {
    isMapVisible,
    mapKey,
    onMarkerClick,
    locations,
    myMapRef,
    mapCenter,
    selectDealerInfo,
    focusOnDealer,
  };
};

/**
 * 1.获取经销商的地方写死了
 * 2.产品下单的地方处理完成了 周一再测测
 *  */
const useTdMapChangeCenterEffect = () => {
  const tdmapref = ref(null);
  // 用于根据搜索 / 定位结果，重新设置中心点（同时刷新附近门店）
  const tdMapToCenterFunc = (latitude, longitude) => {
    if (tdmapref.value) {
      tdmapref.value.onGoMapCenter({
        longitude,
        latitude,
      });
    }
  };
  // 用于列表点击门店时，只高亮门店位置，不改变“我的位置”图标
  const tdMapFocusDealerFunc = (latitude, longitude, dealer) => {
    if (tdmapref.value && tdmapref.value.onFocusDealer) {
      tdmapref.value.onFocusDealer({
        longitude,
        latitude,
        dealer,
      });
    }
  };
  return { tdmapref, tdMapToCenterFunc, tdMapFocusDealerFunc };
};

// 获取到具体的经纬度以后 定位到具体的地点
const useMapChangeCenterEffect = (
  mapCenter,
  locations,
  dealerList,
  city,
  currentLocation
) => {
  const getAllDistrictList = async (provinceId) => {
    const param = { provinceIdEqual: [provinceId] };
    const query = [];
    Object.keys(param).forEach((key) => {
      const list = param[key];
      if (Array.isArray(list)) {
        const innerquery = list
          .filter((item) => item)
          .map((item) => `${key}=${item}`)
          .join("&");
        if (innerquery) query.push(innerquery);
      }
    });
    const finalquery = query.join("&");
    const res = await getMultiLevelDistrictApi(finalquery, null);
    if (res.error == null) return res.data.list || [];
    return [];
  };

  const getNearbyDealerFunc = async (latitude, longitude, provinceId) => {
    if (!provinceId) return [];
    const allDistrictList = await getAllDistrictList(provinceId);
    if (!allDistrictList || allDistrictList.length === 0) {
      dealerList.value = [];
      return [];
    }
    const districtIdList = allDistrictList.map((item) => item.id);
    const param = { districtIdEqual: [districtIdList] };
    const query = [];
    Object.keys(param).forEach((key) => {
      const list = param[key];
      if (Array.isArray(list)) {
        const innerquery = list
          .filter((item) => item)
          .map((item) => `${key}=${item}`)
          .join("&");
        if (innerquery) query.push(innerquery);
      } else {
        query.push(`${key}=${list}`);
      }
    });
    const finalquery = query.join("&");
    const res = await getOpenRetailerListApi(finalquery, null);
    if (res.error != null) return [];
    const list = Array.isArray(res?.data?.list) ? res.data.list : [];
    // list.push({ ...list[0] });
    (list || []).forEach((item, index) => {
      // 兼容部分门店返回字段差异（lat/lon）
      const lat = item?.latitude ?? item?.lat;
      const lng = item?.longitude ?? item?.lon ?? item?.lng;
      item.latitude = lat;
      item.longitude = lng;

      // 小范围兜底：历史数据里该地址经纬度缺失
      // if (item.address === "oneone floor") {
      //   item.latitude = "3.1578";
      //   item.longitude = "101.7119";
      // }
      // if (item.address === "twotwo floor") {
      //   item.latitude = "1.4576";
      //   item.longitude = "103.7611";
      // }
      // if (index == 1 && item.address === "oneone floor") {
      //   item.latitude = "3.139";
      //   item.longitude = "101.6869";
      // }
    });
    (list || []).forEach((it) => {
      const latNum = Number(it?.latitude);
      const lngNum = Number(it?.longitude);
      if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return;
      console.log("Number(latitude)", Number(latitude));
      console.log("Number(longitude)", Number(longitude));
      it.distancekm = calcDistanceKm(
        { lat: Number(currentLocation.lat), lng: Number(currentLocation.lng) },
        { lat: latNum, lng: lngNum }
      );
      console.log("Number(longitude kmkm)", it.distancekm);
    });
    list.sort(
      (a, b) =>
        Number(a?.distancekm ?? Infinity) - Number(b?.distancekm ?? Infinity)
    );

    dealerList.value = list;
    console.log("Number(longitude kmkm)11111", dealerList.value);
    return list;
  };

  const mapToCenterFunc = async (
    latitude,
    longitude,
    allowLocation = true,
    provinceId = city.value,
    showMyLocation = true
  ) => {
    locations.value.splice(0, locations.value.length);
    mapCenter.value = { lat: Number(latitude), lng: Number(longitude) };
    // currentLocation.lat = Number(latitude);
    // currentLocation.lng = Number(longitude);
    // if (allowLocation) {
    // }
    // 然后都换成中心点的位置

    locations.value.push({
      position: {
        lat: Number(currentLocation.lat),
        lng: Number(currentLocation.lng),
      },
      icon: {
        url: myLocationIcon,
        scaledSize: { width: 40, height: 40 },
      },
      id: "self",
      title: "Self",
    });
    console.log("locations.value hahahahah", locations.value);

    const list = await getNearbyDealerFunc(latitude, longitude, provinceId);
    console.log("我真的是数据", list);
    // 同坐标聚合：多个门店共用一个 marker，marker 上显示数量
    const grouped = new Map();
    (list || []).forEach((element) => {
      const latNum = Number(element?.latitude);
      const lngNum = Number(element?.longitude);
      if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return;
      const key = `${latNum.toFixed(6)},${lngNum.toFixed(6)}`;
      if (!grouped.has(key)) {
        grouped.set(key, { latNum, lngNum, dealers: [] });
      }
      grouped.get(key).dealers.push(element);
    });
    grouped.forEach((group) => {
      const first = group.dealers[0];
      const count = group.dealers.length;
      locations.value.push({
        position: {
          lat: group.latNum,
          lng: group.lngNum,
        },
        icon: {
          url: positionOtherIcon,
          scaledSize: { width: 40, height: 40 },
        },
        label:
          count > 1
            ? {
                text: String(count),
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "700",
              }
            : null,
        id: "dealer",
        fullName: first?.fullName,
        address: first?.address,
        endLatitude: first?.latitude,
        endLongitude: first?.longitude,
        groupDealers: group.dealers,
      });
    });
  };
  return { mapToCenterFunc, getNearbyDealerFunc };
};

// 定位相关
const useMapPositionEffect = (
  mapToCenterFunc,
  mapCenter,
  city,
  hasLocatedSuccessfully,
  currentLocation,
  kualaLumpurLocation
) => {
  // 获取用户当前定位
  const getUserLocation = () => {
    if (!navigator.geolocation) {
      // alert("您的浏览器不支持地理定位功能");
      showFailToast("Your browser does not support geolocation functionality");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        hasLocatedSuccessfully.value = true;
        mapCenter.value.lat = latitude;
        mapCenter.value.lng = longitude;

        currentLocation.lat = latitude;
        currentLocation.lng = longitude;

        mapToCenterFunc(
          latitude,
          longitude,
          true,
          city.value || CHINA_DEFAULT_PROVINCE_ID,
          true
        );
      },
      (error) => {
        hasLocatedSuccessfully.value = false;
        console.error("定位失败:", error.message);
        showToast("please check location permissions");
        // alert("无法获取当前位置，请检查定位权限");
        // 中心点的文职 默认用的吉隆坡的地址
        currentLocation.lat = kualaLumpurLocation.lat;
        currentLocation.lng = kualaLumpurLocation.lng;
        setTimeout(() => {
          mapToCenterFunc(
            mapCenter.value.lat,
            mapCenter.value.lng,
            false,
            city.value || CHINA_DEFAULT_PROVINCE_ID,
            true
          );
        }, 500);
      }
    );
  };
  return {
    getUserLocation,
  };
};

const useReloadMapEffect = (isMapVisible, mapKey, tdmapref) => {
  const onReloadMap = () => {
    if (!isInChina()) {
      isMapVisible.value = false; // 隐藏地图
      // 移除旧的 Google Maps 脚本
      const oldScript = document.querySelector(
        'script[src*="maps.googleapis"]'
      );
      if (oldScript) {
        oldScript.remove();
      }
      // 创建新的 Google Maps 脚本
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&language=en-US&region=CN&libraries=places&callback=VueGoogleMapsInit`;
      script.async = true;
      // 设置全局回调函数
      window.VueGoogleMapsInit = () => {
        console.log("加载成功");
        mapKey.value += 1; // 修改 key，强制重新加载地图
        isMapVisible.value = true; // 显示地图
      };
      // 捕获脚本加载失败
      script.onerror = () => {
        // console.error("谷歌地图加载失败！！！！");
        showFailToast("map load error");
      };
      document.head.appendChild(script);
    } else {
      // 用的天地图
      if (tdmapref.value) {
        tdmapref.value.onReload();
      }
    }
  };
  return { onReloadMap };
};

export default {
  name: "Home",
  components: { Docker, TianDiTuMap, MapStorePanel },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const kualaLumpurLocation = { lat: 3.139, lng: 101.6869 };
    const { from } = route.query;
    const { t, locale } = useI18n(); // 获取 t 方法
    const { onSystemChangeLanguage } = useNewLanguageEffect();
    const showDocker = ref(true);

    const normalizeLangFromQuery = (lang) => {
      const value = String(lang || "")
        .trim()
        .toLowerCase();
      if (value === "en" || value === "en-us") return "en-US";
      if (value === "zh" || value === "zh-cn") return "zh-CN";
      if (value === "ms" || value === "ms-my" || value === "my") return "ms-MY";
      return "";
    };

    // 支持 URL 控制语言：?lang=en / ?lang=zh
    watch(
      () => route.query.lang,
      (lang) => {
        const nextLang = normalizeLangFromQuery(lang);
        if (nextLang) onSystemChangeLanguage(nextLang);
      },
      { immediate: true }
    );

    // 支持 URL 控制语言：?lang=en / ?lang=zh
    watch(
      () => route.query.iframe,
      (iframe) => {
        showDocker.value = iframe != "embedded";

        // const nextLang = normalizeLangFromQuery(lang);
        // if (nextLang) onSystemChangeLanguage(nextLang);
      },
      { immediate: true }
    );

    const showBackImg = ref(false);
    const isShowGoogleMap = ref(true);
    const dealerList = ref([]);
    const keyword = ref("");
    const locationPermission = ref(true);
    const city = ref(CHINA_DEFAULT_PROVINCE_ID);
    const currentLocation = reactive({});
    const activeDealerKey = ref(null);
    const activeDealerItem = ref(null);
    const hasLocatedSuccessfully = ref(false);

    // watch(
    //   () => currentLocation,
    //   (val) => {
    //     console.log("currentLocation one 被改变了", val);
    //   }
    // );

    // setTimeout(() => {
    //   console.log("currentLocation one 被改变了", currentLocation);
    // }, 10 * 1000);

    // 始终中心点
    // const mapAlwaysCenter = ref(
    //   isInChina()
    //     ? { lat: 31.2155, lng: 121.417 }
    //     : { lat: 3.139, lng: 101.6869 }
    // );
    // 用户切换省份后：清掉上一次选中的门店高亮状态（避免切回仍保留选中态）
    watch(
      () => city.value,
      () => {
        activeDealerKey.value = null;
      }
    );
    const { tdmapref, tdMapToCenterFunc, tdMapFocusDealerFunc } =
      useTdMapChangeCenterEffect();
    if (from == "web") {
      showBackImg.value = true;
    }
    if (isInChina()) {
      isShowGoogleMap.value = false;
    }

    // map的一些东西
    const {
      onMarkerClick: baseMarkerClick,
      locations,
      isMapVisible,
      mapKey,
      myMapRef,
      mapCenter,
      selectDealerInfo,
      focusOnDealer: googleFocusDealerFunc,
    } = useMapEffect(t);

    // 手机端地图标记弹框显隐
    const showMarkerPopup = ref(false);

    // 定位的功能
    const { mapToCenterFunc, getNearbyDealerFunc } = useMapChangeCenterEffect(
      mapCenter,
      locations,
      dealerList,
      city,
      currentLocation
    );
    const getProvinceTextById = (provinceId) => {
      const list = CHINA_ALL_PROVINCE || [];
      const hit = list.find((x) => String(x.value) === String(provinceId));
      return hit?.textEn || hit?.enText || hit?.text || "";
    };
    const MALAYSIA_PROVINCE_CENTER = {
      KualaLumpur: { lat: 3.139, lng: 101.6869 },
      Selangor: { lat: 3.0738, lng: 101.5183 },
      PulauPinang: { lat: 5.4141, lng: 100.3288 },
      Sabah: { lat: 5.9788, lng: 116.0753 },
      Johor: { lat: 1.4927, lng: 103.7414 },
      Melaka: { lat: 2.1896, lng: 102.2501 },
      Sarawak: { lat: 1.5533, lng: 110.3592 },
      Putrajaya: { lat: 2.9264, lng: 101.6964 },
      NegeriSembilan: { lat: 2.7297, lng: 101.9381 },
      Pahang: { lat: 3.8077, lng: 103.326 },
      Perak: { lat: 4.5975, lng: 101.0901 },
      Kedah: { lat: 6.121, lng: 100.3673 },
      Kelantan: { lat: 6.1254, lng: 102.2386 },
      Trengganu: { lat: 5.3302, lng: 103.1408 },
      Perlis: { lat: 6.4449, lng: 100.2048 },
      Labuan: { lat: 5.2831, lng: 115.2308 },
    };
    const getProvinceFallbackCenter = (provinceId) => {
      const text = getProvinceTextById(provinceId);
      return text ? MALAYSIA_PROVINCE_CENTER[text] : null;
    };
    const flyGoogleToProvince = async (provinceId) => {
      if (!provinceId || isInChina()) return;
      try {
        const seedLat = Number(mapCenter.value?.lat ?? 3.139);
        const seedLng = Number(mapCenter.value?.lng ?? 101.6869);
        const list = await getNearbyDealerFunc(seedLat, seedLng, provinceId);
        const first = (list || []).find((it) => it?.latitude && it?.longitude);
        if (first) {
          mapToCenterFunc(
            Number(first.latitude),
            Number(first.longitude),
            hasLocatedSuccessfully.value,
            provinceId
          );
          return;
        }
      } catch (e) {}
      const fallback = getProvinceFallbackCenter(provinceId);
      if (fallback) {
        mapToCenterFunc(
          fallback.lat,
          fallback.lng,
          hasLocatedSuccessfully.value,
          provinceId
        );
      }
    };
    watch(
      () => city.value,
      (v) => {
        if (!isInChina()) {
          flyGoogleToProvince(v);
        }
      }
    );

    // 浏览器定位到当前位置
    const { getUserLocation } = useMapPositionEffect(
      mapToCenterFunc,
      mapCenter,
      city,
      hasLocatedSuccessfully,
      currentLocation,
      kualaLumpurLocation
    );
    // const {} = useMapPositionEffect();

    const { onSearchClick } = useSearchContentEffect(
      mapToCenterFunc,
      tdMapToCenterFunc
    );

    const { onReloadMap } = useReloadMapEffect(isMapVisible, mapKey, tdmapref);

    const { onGotoPlace } = useNavigatorEffect(selectDealerInfo);

    onActivated(() => {
      console.log("Component is activated");
    });

    onDeactivated(() => {
      console.log("Component is deactivated");
    });

    onMounted(() => {
      if (!isInChina()) {
        myMapRef.value.$mapPromise
          .then((mapObject) => {
            console.log("map is loaded now", mapObject);
            // 进行定位
            getUserLocation();
          })
          .catch((error) => {
            console.log("map is loaded failed", error);
          });

        window.gm_authFailure = () => {
          // console.error("Google Maps authentication failed.");
          showFailToast("Google Maps authentication failed.");
        };
      }
    });

    const onBackClick = () => {
      // router.replace({ name: "Login" });
      router.back();
    };

    const onTdDealerList = (list) => {
      dealerList.value = Array.isArray(list) ? list : [];
    };

    const onSelectDealerFromList = ({ item, key }) => {
      activeDealerKey.value = key;
      activeDealerItem.value = item || null;
      if (!item) return;
      console.log("onSelectDealerFromList one", item);
      const lat = item.latitude ?? item.lat ?? item.endLatitude;
      const lng = item.longitude ?? item.lng ?? item.endLongitude;
      console.log("onSelectDealerFromList", lat, lng);
      if (lat && lng) {
        if (!isInChina()) {
          googleFocusDealerFunc(Number(lat), Number(lng), item);
        } else {
          // 中国境内：列表点击门店时，仅高亮门店位置，不修改“我的位置”图标
          // 同时把门店信息传给地图，确保高亮标记点击也能弹框
          tdMapFocusDealerFunc(Number(lat), Number(lng), item);
        }
      } else {
        showToast(t("app.home.map_popup_location_error"));
      }
    };

    const onNavigateFromList = ({ item, key }) => {
      activeDealerKey.value = key;
      if (!item) return;
      console.log("currentLocation.lat one", currentLocation);

      console.log("currentLocation.lat", currentLocation.lat);
      console.log("currentLocation.lng", currentLocation.lng);

      selectDealerInfo.fullName = item.fullName;
      selectDealerInfo.address = item.address;
      selectDealerInfo.endLatitude = item.latitude ?? item.endLatitude;
      selectDealerInfo.endLongitude = item.longitude ?? item.endLongitude;
      selectDealerInfo.startLatitude = currentLocation.lat;
      selectDealerInfo.startLongitude = currentLocation.lng;
      onGotoPlace();
    };

    const popupDealerList = ref([]);
    const popupDealerIndex = ref(0);
    const syncPopupDealerInfo = (dealer) => {
      if (!dealer) return;
      selectDealerInfo.fullName = dealer.fullName;
      selectDealerInfo.address = dealer.address;
      selectDealerInfo.phone = dealer.phoneNumber || dealer.phone;
      selectDealerInfo.authRange =
        dealer.authorizationStartDate && dealer.authorizationEndDate
          ? `${dealer.authorizationStartDate}至${dealer.authorizationEndDate}`
          : "";
      selectDealerInfo.distanceText =
        dealer.distancekm != null ? `${dealer.distancekm}km` : "";
      selectDealerInfo.endLatitude =
        dealer.latitude ?? dealer.endLatitude ?? dealer.lat;
      selectDealerInfo.endLongitude =
        dealer.longitude ?? dealer.endLongitude ?? dealer.lng;
      selectDealerInfo.startLatitude =
        currentLocation.lat ?? mapCenter.value.lat;
      selectDealerInfo.startLongitude =
        currentLocation.lng ?? mapCenter.value.lng;
    };

    const onMarkerClick = (location, mapcenter) => {
      baseMarkerClick(location, mapcenter);
      if (location && location.id === "dealer") {
        const groupedFromMarker = Array.isArray(location.groupDealers)
          ? location.groupDealers
          : [];
        const lat = Number(location.endLatitude ?? location.latitude);
        const lng = Number(location.endLongitude ?? location.longitude);
        const groupedFromList = (dealerList.value || []).filter((d) => {
          const dLat = Number(d.latitude ?? d.endLatitude ?? d.lat);
          const dLng = Number(d.longitude ?? d.endLongitude ?? d.lng);
          if (!Number.isFinite(dLat) || !Number.isFinite(dLng)) return false;
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
          return (
            dLat.toFixed(6) === lat.toFixed(6) &&
            dLng.toFixed(6) === lng.toFixed(6)
          );
        });
        const grouped =
          groupedFromMarker.length > 0 ? groupedFromMarker : groupedFromList;
        popupDealerList.value =
          grouped.length > 0
            ? grouped
            : [
                {
                  fullName: location.fullName,
                  address: location.address,
                  latitude: location.endLatitude ?? location.latitude,
                  longitude: location.endLongitude ?? location.longitude,
                },
              ];

        console.log("popupDealerList", popupDealerList.value);
        // 若当前已在门店列表选中过同坐标门店，弹框默认定位到该门店
        const currentSelected = activeDealerItem.value;
        let defaultIdx = 0;
        if (currentSelected && popupDealerList.value.length > 1) {
          const sLat = Number(
            currentSelected.latitude ??
              currentSelected.endLatitude ??
              currentSelected.lat
          );
          const sLng = Number(
            currentSelected.longitude ??
              currentSelected.endLongitude ??
              currentSelected.lng
          );
          defaultIdx = popupDealerList.value.findIndex((d) => {
            const dLat = Number(d.latitude ?? d.endLatitude ?? d.lat);
            const dLng = Number(d.longitude ?? d.endLongitude ?? d.lng);
            const sameCoord =
              Number.isFinite(sLat) &&
              Number.isFinite(sLng) &&
              Number.isFinite(dLat) &&
              Number.isFinite(dLng) &&
              sLat.toFixed(6) === dLat.toFixed(6) &&
              sLng.toFixed(6) === dLng.toFixed(6);
            const sameId =
              currentSelected.id != null &&
              d.id != null &&
              String(currentSelected.id) === String(d.id);
            const sameName =
              currentSelected.fullName &&
              d.fullName &&
              currentSelected.fullName === d.fullName;
            return sameId || (sameCoord && sameName);
          });
          if (defaultIdx < 0) defaultIdx = 0;
        }
        popupDealerIndex.value = defaultIdx;
        syncPopupDealerInfo(popupDealerList.value[popupDealerIndex.value]);
        // 仅 Google 地图点击时联动列表高亮；天地图点击不联动门店列表
        if (!isInChina()) {
          const hit = (dealerList.value || []).find((d) => {
            const dLat = d.latitude ?? d.endLatitude;
            const dLng = d.longitude ?? d.endLongitude;
            const sameCoord =
              dLat != null && dLng != null && dLat == lat && dLng == lng;
            const sameName =
              d.fullName &&
              location.fullName &&
              d.fullName === location.fullName;
            return sameCoord || sameName;
          });
          if (hit) {
            const idx = (dealerList.value || []).indexOf(hit);
            activeDealerKey.value = hit.id ?? idx;
          }
        }
        // 点击地图标记时，打开手机端弹框
        showMarkerPopup.value = true;
      }
    };
    const onPickPopupDealer = (dealer, idx) => {
      popupDealerIndex.value = idx;
      syncPopupDealerInfo(dealer);
    };
    return {
      locations,
      isMapVisible,
      mapKey,
      myMapRef,
      onMarkerClick,
      mapCenter,
      selectDealerInfo,
      showMarkerPopup,
      popupDealerList,
      popupDealerIndex,
      onPickPopupDealer,

      onSearchClick,
      onReloadMap,

      onGotoPlace,
      onBackClick,
      showBackImg,

      tdmapref,
      isShowGoogleMap,

      dealerList,
      keyword,
      city,
      currentLocation,
      activeDealerKey,
      onTdDealerList,
      onSelectDealerFromList,
      onNavigateFromList,

      popupIconLoc,
      popupIconPhone,
      popupIconNav,
      locationPermission,
      showDocker,
    };
  },
};
</script>




<style lang="scss" scoped>
.wrapper {
  overflow-y: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.wrapper__search {
  overflow-y: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0.5rem;
  z-index: 99;
}
.refreshwrapper {
  position: absolute;
  bottom: 0.2rem;
  right: 0.1rem;
  &__img {
    width: 0.5rem;
    height: 0.5rem;
  }
  z-index: 999;
}
.back__img {
  position: absolute;
  top: 1%;
  left: 3%;
  width: 0.3rem;
  height: 0.3rem;
  z-index: 9999;
}
::v-deep(.vue-map-container) {
  height: 100%;
}
::v-deep(.van-cell__title) {
  text-align: left;
}

/* 手机端地图标记弹框遮罩 + 居中卡片 */
.mobilePopupMask {
  position: fixed;
  inset: 0;
  /* 调低层级，避免遮挡 Vant Dialog / 浏览器提示弹框（如“请安装高德导航”） */
  z-index: 1999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  padding: 0.16rem;
  box-sizing: border-box;
}

.mobilePopup {
  position: relative;
  width: 3.2rem;
  max-width: 100%;
  background: #fff;
  border-radius: 0.12rem;
  box-shadow: 0 0.06rem 0.24rem rgba(0, 0, 0, 0.18);
  padding: 0.18rem 0.16rem 0.16rem;
  box-sizing: border-box;

  &__close {
    position: absolute;
    right: 0.1rem;
    top: 0.1rem;
    font-size: 0.18rem;
    color: #999;
  }

  &__title {
    font-size: 0.14rem;
    font-weight: 700;
    color: #383838;
    line-height: 1.25;
    padding-right: 0.28rem;
    text-align: left;
  }

  &__badge {
    display: inline-block;
    margin-top: 0.08rem;
    padding: 0.04rem 0.12rem;
    border-radius: 0.12rem;
    border: 1px solid #009343;
    color: #009343;
    font-size: 0.1rem;
    background: rgba(0, 147, 67, 0.06);
  }

  &__switchList {
    margin-top: 0.08rem;
    max-height: 1.2rem;
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    border-radius: 0.08rem;
  }

  &__switchItem {
    padding: 0.08rem 0.1rem;
    font-size: 0.12rem;
    color: #383838;
    text-align: left;
    border-bottom: 1px solid #f2f2f2;
  }
  &__switchItem:last-child {
    border-bottom: none;
  }
  &__switchItem--active {
    color: #009343;
    background: rgba(0, 147, 67, 0.08);
    font-weight: 600;
  }

  &__row {
    display: flex;
    gap: 0.08rem;
    margin-top: 0.12rem;
    align-items: flex-start;
  }

  &__icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-top: 0.02rem;
    flex-shrink: 0;
    object-fit: contain;
  }

  &__text {
    flex: 1;
    font-size: 0.12rem;
    color: #383838;
    line-height: 1.25;
    word-break: break-all;
    text-align: left;
  }

  &__btn {
    width: 100%;
    margin-top: 0.14rem;
    height: 0.38rem;
    border: none;
    border-radius: 0.19rem;
    background: #009343;
    color: #fff;
    font-size: 0.14rem;
  }
}

/* 弹框出现/消失动画：遮罩淡入淡出 + 卡片自下而上浮现并放大 */
.mobilePopup-enter-active,
.mobilePopup-leave-active {
  transition: opacity 0.25s ease-out;
}

.mobilePopup-enter-from,
.mobilePopup-leave-to {
  opacity: 0;
}

/* 卡片本身的放大 + 上移动画 */
.mobilePopup-enter-active .mobilePopup,
.mobilePopup-leave-active .mobilePopup {
  transition: transform 0.25s ease-out, opacity 0.25s ease-out;
}

.mobilePopup-enter-from .mobilePopup {
  transform: translateY(24px) scale(0.9);
  opacity: 0;
}

.mobilePopup-leave-to .mobilePopup {
  transform: translateY(24px) scale(0.9);
  opacity: 0;
}
</style>
